import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocScheduleGlobalRoute: InvariantJiraRoute = {
	name: 'eoc-schedules',
	path: '/jira/settings/products/ops/schedules',
	exact: true,
};
